/**
 * Section content is AI-written and user-editable, so it is untrusted HTML.
 * Moved unchanged from the Sales wizard (sales-client ReportWizard, pre-#PR2a).
 */
export function escapeHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Keep only a safe set of formatting tags and drop EVERY attribute on them.
 * A tag-name allowlist that kept attributes would let `<p onmouseover=...>` or a
 * CSS url() through into dangerouslySetInnerHTML.
 */
export function sanitizeHtml(html: string): string {
  const ALLOWED = /^(p|strong|em|b|i|ul|ol|li|br|h[1-3])$/i;
  return html.replace(/<(\/?)([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>/g, (_match, slash: string, tag: string) =>
    ALLOWED.test(tag) ? `<${slash}${tag.toLowerCase()}>` : '');
}

/** The text a person sees, for the plain editor. */
export function htmlToText(html: string): string {
  const div = document.createElement('div');
  div.innerHTML = sanitizeHtml(html).replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>\s*<p>/gi, '</p>\n\n<p>');
  return div.textContent ?? '';
}

/** Plain text back to paragraphs: a blank line splits paragraphs, a newline becomes <br/>. */
export function textToHtml(text: string): string {
  return text
    .trim()
    .split('\n\n')
    .filter(Boolean)
    .map((p) => `<p>${escapeHtml(p).replace(/\n/g, '<br/>')}</p>`)
    .join('');
}
